var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-loader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"36","width":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }